export default __webpack_public_path__ + "static/media/Selfielocation_temp.53e497d9.png";